// screens/App.tsx
import * as React from "react";
import { HashRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import WindowAppbar from "./sections/core/Appbar";
import AppScreens from "./AppScreens";

const App: React.FC = () => {

  let isMac = process.platform == 'darwin';

  return (
    <ErrorBoundary>
      {!isMac && <WindowAppbar />}
      <Router>
         <AppScreens />
      </Router>
    </ErrorBoundary>
  );
};

export default App;
